import {
  ApiConfigService,
  PreferenceService,
  ConfigService,
  SessionService,
  Logger,
} from '@nextgen-web-framework/core';
import { i18n } from 'i18n/routingUtil';
import { ConfigDataInterface } from 'types/common';
import logObject from 'utils/logObject';

const logger = Logger.getInstance(logObject('setServiceValues.ts'));

const mergeCountrySpecificSecrets = (configData: ConfigDataInterface, country: string) => {
  const countrySpecificSecrets = {} as Record<string, string | Record<string, unknown>>;
  for (const secretKey of Object.keys(configData?.secrets)) {
    const secretFileContent = configData?.secrets[secretKey as keyof typeof configData.secrets];
    try {
      const countrySpecificData = JSON.parse(secretFileContent);
      countrySpecificSecrets[secretKey] = countrySpecificData[country];
    } catch (err) {
      // nothing to do here
      logger.log(err);
    }
  }
  if (configData?.configs) {
    if (country in configData.configs) {
      configData.configs[country] = {
        ...(configData.configs[country] as unknown as Record<string, unknown>),
        ...countrySpecificSecrets,
      };
    } else {
      configData.configs[country] = countrySpecificSecrets;
    }
  }
};

const setServiceValues = (configData: ConfigDataInterface, locale: string, country?: string) => {
  if (country) {
    mergeCountrySpecificSecrets(configData, country);
  }
  ConfigService.setConfigs({
    ...configData.configs,
    ...configData.secrets,
  });
  ApiConfigService.setBaseUrl(configData.configs.NEXT_PUBLIC_BASE_PATH as string);
  ApiConfigService.setTuples({
    'X-Amway-Channel': configData.configs.channel as string,
    'X-Amway-Tenant': configData.configs.NEXT_PUBLIC_TENANT as string,
    'X-Amway-Country': configData.configs.NEXT_PUBLIC_COUNTRY as string,
  });
  PreferenceService.setPreferences({
    currency: configData.configs.NEXT_PUBLIC_CURRENCY as string,
    locale: locale ?? i18n().defaultLocale,
  });

  SessionService.setSession({
    ...(SessionService.getSession() ?? {}),
    currentCountry: country ?? (configData?.configs?.NEXT_PUBLIC_COUNTRY as string),
  });
};

export default setServiceValues;
